const prod = require('./apiUrls.prod')
const dev = require('./apiUrls.dev')

const urls = process.env.VUE_APP_MODE === 'preview' ? Object.assign({}, prod, dev) : prod

export default urls
